export const INSTANCE_ID = 'urx-form';
// The required urx form-id to be embedded
export const FORM_ID = 'QTE-automation';
export const LOCALE = 'us-en';
